import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import ModalPortal from "../../../Portales/Modal/Modal.portal";
import "./ModalConfirmacion.component.scss";

const ModalConfirmacionComponent = ({
  children,
  mostrar,
  handleCerrar,
  handleSi,
  handleNo,
}) => {
  const [mostrarModal, setMostrarModal] = useState(false);

  const Footer = () => {
    return (
      <div className="row">
        <div className="col-12">
          <Button
            variant="outline-secondary"
            className="mr-2"
            onClick={noModal}
          >
            No
          </Button>
          <Button variant="primary" onClick={siModal}>
            Sí
          </Button>
        </div>
      </div>
    );
  };

  const siModal = () => {
    handleSi();
  };

  const noModal = () => {
    handleNo();
  };

  useEffect(() => {
    setMostrarModal(mostrar);
  }, [mostrar]);

  return (
    <ModalPortal
      mostrar={mostrarModal}
      handleCerrar={handleCerrar}
      footer={Footer()}
      tamano="lg"
    >
      {children}
    </ModalPortal>
  );
};

export default ModalConfirmacionComponent;
